export default "__VITE_ASSET__185ae262__$_?nuxt_component=async__"